import styled from "styled-components";
import { fontFamilies, fontSizes } from "components/shared/tokens/typography";

const MOBILE = "@media (max-width: 480px)";
const TABLET = "@media (min-width: 768px) and (max-width: 992px)";
const DESKTOP = "@media (min-width: 768px)";

const COLORS = {
  white: "#ffffff",
  noImage: "rgba(230, 233, 239, 1)",
};

const SHADOW = {
  hero: "0 8px 24px rgba(28, 28, 28, 0.08)",
  heroMobile: "0 6px 18px rgba(28, 28, 28, 0.06)",
};

const RADIUS = {
  mobileCard: "16px",
  hero: "18px",
  pill: "999px",
};

export const HeroCarousel = styled.section`
  position: relative;
  width: 100%;
`;

export const HeroViewport = styled.div`
  width: 100%;
  overflow: hidden;
  border-radius: ${RADIUS.hero};
  box-shadow: ${SHADOW.hero};

  ${MOBILE} {
    border-radius: ${RADIUS.mobileCard};
    box-shadow: ${SHADOW.heroMobile};
  }
`;

export const HeroTrack = styled.div`
  display: flex;
  width: 100%;
  will-change: transform;
`;

export const HeroSlide = styled.div`
  flex: 0 0 100%;
  min-width: 0;
`;

export const HeroCard = styled.button`
  position: relative;
  width: 100%;
  min-height: 260px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.55);
  border-radius: ${RADIUS.hero};
  padding: 0;
  background: ${props => props.$backgroundImage
    ? `url("${props.$backgroundImage}") center / cover no-repeat`
    : COLORS.noImage};
  color: ${COLORS.white};
  text-align: left;
  cursor: pointer;

  &:disabled {
    cursor: default;
  }

  ${DESKTOP} {
    aspect-ratio: 1200 / 150;
    height: auto;
    min-height: 110px;
    border-radius: 16px;
  }

  ${MOBILE} {
    min-height: 0;
    height: clamp(136px, 38vw, 148px);
    border-radius: ${RADIUS.mobileCard};
  }
`;

export const HeroCopy = styled.div`
  position: relative;
  z-index: 1;
  max-width: min(48%, 460px);
  padding: 28px 30px 22px;

  ${TABLET} {
    max-width: 58%;
    padding: 16px 16px 14px;
  }

  ${MOBILE} {
    max-width: 64%;
    padding: 14px 14px 12px;
  }
`;

export const HeroEyebrow = styled.div`
  margin-bottom: 10px;
  color: rgba(255, 255, 255, 0.78);
  font-family: ${fontFamilies.semiBold};
  font-size: ${fontSizes.z200};
  font-weight: 600;
  line-height: 1.3;

  ${MOBILE} {
    margin-bottom: 6px;
    font-size: 12px;
    line-height: 1.25;
  }
`;

export const HeroTitle = styled.div`
  margin-bottom: 18px;
  color: ${COLORS.white};
  font-family: ${fontFamilies.bold};
  font-size: ${fontSizes.z500};
  font-weight: 700;
  line-height: 1.3;

  ${DESKTOP} {
    font-size: 34px;
    line-height: 1.18;
  }

  ${TABLET} {
    margin-bottom: 12px;
    font-size: 22px;
    line-height: 1.2;
  }

  ${MOBILE} {
    margin-bottom: 12px;
    font-size: 20px;
    line-height: 1.22;
  }
`;

export const HeroCta = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  background: #000000;
  color: ${COLORS.white};
  font-family: ${fontFamilies.bold};
  font-size: ${fontSizes.z300};
  font-weight: 700;

  ${MOBILE} {
    min-height: 36px;
    padding: 0 12px;
    border-radius: 8px;
    font-size: 14px;
  }
`;

export const HeroDots = styled.div`
  position: absolute;
  z-index: 2;
  left: 50%;
  bottom: 12px;
  display: flex;
  gap: 6px;
  transform: translateX(-50%);

  button {
    position: relative;
    width: 8px;
    height: 8px;
    overflow: hidden;
    padding: 0;
    border: 0;
    border-radius: ${RADIUS.pill};
    background: rgba(255, 255, 255, 0.45);
    cursor: pointer;
    transition: width 300ms ease;
  }

  button[data-active="true"] {
    width: 28px;
    background: rgba(255, 255, 255, 0.38);
  }

  button span {
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: ${COLORS.white};
    transform: scaleX(0);
    transform-origin: left center;
    will-change: transform;
  }

  ${MOBILE} {
    bottom: 8px;
    gap: 4px;

    button {
      width: 5px;
      height: 5px;
    }

    button[data-active="true"] {
      width: 24px;
    }
  }
`;
